import FunctionReadView from './FunctionReadView';

export default FunctionReadView;
